import { createActions, createReducer } from 'reduxsauce'
import labels from '../components/Filtro/Labels'

const meses = [
    { value: '1', label: labels['janeiro'] },
    { value: '2', label: labels['fevereiro'] },
    { value: '3', label: labels['marco'] },
    { value: '4', label: labels['abril'] },
    { value: '5', label: labels['maio'] },
    { value: '6', label: labels['junho'] },
    { value: '7', label: labels['julho'] },
    { value: '8', label: labels['agosto'] },
    { value: '9', label: labels['setembro'] },
    { value: '10', label: labels['outubro'] },
    { value: '11', label: labels['novembro'] },
    { value: '12', label: labels['dezembro'] },
]

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setAdministracaoConsultaPagamentoContraCheque: ['administracao'],
    setExercicioConsultaPagamentoContraCheque: ['exercicio'],
    setMesConsultaPagamentoContraCheque: ['mes'],
    setNomeConsultaPagamentoContraCheque: ['nome'],
    setCpfConsultaPagamentoContraCheque: ['cpf'],
    setCargoConsultaPagamentoContraCheque: ['cargo'],
    limpaFiltroConsultaPagamentoContraCheque: [],
    receberFiltroConsultaPagamentoContraCheque: ['filtroRecebido'],
    setStatusConsultaPagamentoContraCheque: ['status'],
})

const INITIAL_STATE = {
    administracao: [],
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    mes: { value: (new Date().getMonth() + 1).toString(), label: meses[new Date().getMonth()].label },
    nome: '',
    cpf: '',

    cargo: [],
    status: { label: '', value: '' },
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setMes = (state = INITIAL_STATE, action) => {
    return { ...state, mes: action.mes }
}

const setNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: action.nome }
}

const setCpf = (state = INITIAL_STATE, action) => {
    return { ...state, cpf: action.cpf }
}

const setCargo = (state = INITIAL_STATE, action) => {
    return { ...state, cargo: action.cargo }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_ADMINISTRACAO_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: setAdministracao,
    [Types.SET_EXERCICIO_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: setExercicio,
    [Types.SET_MES_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: setMes,
    [Types.SET_NOME_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: setNome,
    [Types.SET_CPF_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: setCpf,
    [Types.SET_CARGO_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: setCargo,
    [Types.LIMPA_FILTRO_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_PAGAMENTO_CONTRA_CHEQUE]: setStatus,
})
